import React from "react";
import { Row, Col, Modal, Button, FormInstance } from "antd";
import { useWindowSize } from "../../../hooks/useWindowSize";
import styles from "./PersonModals.module.scss";
import crossMark from "../../../assets/images/CrossMark.png";
import { usePersonFormBackNavigation } from "../../../hooks/usePersonFormBackNavigation";

type Props = {
  form: FormInstance;
  addressType: "homeAddress" | "mailingAddress" | "deliveryAddress";
  visible: boolean;
  setVisibility: Function;
  handleResetAddressLookup: Function;
};

function InvalidAddressModal({
  form,
  visible,
  setVisibility,
  addressType,
  handleResetAddressLookup,
}: Props) {
  const { width } = useWindowSize();

  const enteredAddress = form.getFieldValue(addressType);
  const { navigateBack } = usePersonFormBackNavigation(true);

  function handleCancel() {
    handleResetAddressLookup();
    setVisibility(false);
    navigateBack();
  }

  function handleTryAnotherZipCode() {
    handleResetAddressLookup();
    setVisibility(false);
  }

  return (
    <Modal
      visible={visible}
      className={styles.invalidAddressModalContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "546px"}
      closeIcon={<img src={crossMark} alt="close" />}
      footer={
        <Row justify="center" gutter={[10, 15]}>
          <Col>
            <Button className={styles.cancel} onClick={handleCancel}>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              className={styles.tryAnotherZipCode}
              onClick={handleTryAnotherZipCode}
            >
              Try Another Zip Code
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center">
        <Col span={24} className={styles.title}>
          We're sorry, but Wanda isn't available in your area yet:
        </Col>

        <Col span={24} className={styles.description}>
          {enteredAddress?.city},{enteredAddress?.state}
        </Col>
        <Col span={24} className={styles.description}>
          {enteredAddress?.zip}
        </Col>
      </Row>
    </Modal>
  );
}

export default InvalidAddressModal;
